const ApiService = Shopware.Classes.ApiService;

/**
 * API service for the per product property group settings
 * (slot 'listing' = product boxes, slot 'detail' = product detail page)
 */
class TopdataPbProductExtensionApiService extends ApiService {

    /**
     * @param {Object} topdataPbProductExtension
     */
    updateTopdataPbProductExtension(topdataPbProductExtension) {
        const apiRoute = `topdata-product-boxes/update-topdata-pb-product-extension/${topdataPbProductExtension.id}`;
        return this.httpClient.put(apiRoute, topdataPbProductExtension, this._getDefaultOptions());
    }

    /**
     * Property groups that actually occur on the product, sorted by name.
     *
     * @param {String} productId
     * @returns {Promise<Array<{id: String, name: String}>>}
     */
    getPropertyGroupsOfProduct(productId) {
        const apiRoute = `topdata-product-boxes/property-groups-of-product/${productId}`;
        return this.httpClient.get(apiRoute, this._getDefaultOptions()).then((response) => {
            return response.data.payload;
        });
    }

    _getDefaultOptions() {
        return {
            headers: this.getBasicHeaders(),
        };
    }
}

export default TopdataPbProductExtensionApiService;
